export default __webpack_public_path__ + "static/OYOY-1024x208-30fps-99ea32053bfcf165dac993a209117c87.mp4";